
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getLanguages = async () => {
  try {
    const response = await fetch(`${BASE_URL}/execute-code/languages`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Failed to fetch languages:", error);
    throw error;
  }
};

/**
 * Execute code and get output
 * @param {Object} params
 * @param {string} params.language - Programming language (go, python, java, javascript, etc.)
 * @param {string} params.version - Language version
 * @param {string} params.code - Code to execute
 * @param {string} params.stdin - Optional input for the code
 */
export const executeCode = async ({ language, version, code, stdin = "" }) => {
  try {
    const response = await fetch(`${BASE_URL}/execute-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        language,
        version,
        code,
        stdin,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to execute code:", error);
    throw error;
  }
};

/**
 * Execute test cases and get results
 * @param {Object} params
 * @param {string} params.language - Programming language
 * @param {string} params.version - Language version
 * @param {string} params.code - Code to test
 * @param {Array} params.testCases - Array of test cases with id, input, expected
 */
export const executeTestCases = async ({
  language,
  version,
  code,
  testCases,
}) => {
  console.log("Executing test cases with params:", { BASE_URL });
  try {
    const response = await fetch(`${BASE_URL}/test-cases/execute`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        language,
        version,
        code,
        testCases,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to execute test cases:", error);
    throw error;
  }
};

/**
 * Format code using language-specific formatter
 * @param {Object} params
 * @param {string} params.language - Programming language (go, python, java, javascript, etc.)
 * @param {string} params.code - Code to format
 * @returns {Promise<{formatted: string, success: boolean, error?: string}>}
 */
export const formatCode = async ({ language, code }) => {
  try {
    const response = await fetch(`${BASE_URL}/format-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        language,
        code,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to format code:", error);
    throw error;
  }
};
